export default "__VITE_ASSET__BwwyEQ_i__"